import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXWixSettings implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxWixSettingsContainer";
    }
    render(){
        // console.log("wix settings");

    }
}